import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { closingIncludes, ctaLabel, paymentNote, priceToday, priceTotal } from '../data/content';
export function ClosingBlock() {
  return <section id="cierre" className="w-full scroll-mt-20 bg-ink px-5 py-14 sm:py-24" data-id="element-41" data-mp="2aonz7gs3z9xc">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.5
    }} className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-42" data-mp="25rfhtiesb9x5">
        <h2 className="font-display text-2xl font-bold leading-tight text-surface sm:text-4xl" data-id="element-43" data-mp="1rypvfcvcg2zi">
          Tu primer paso en coreano. Tu método ordenado.{' '}
          <span className="text-pink-light" data-id="element-44" data-mp="1my1unzhbc7s3">Tu plan de 30 días</span> está listo para hoy.
        </h2>
        <p className="mt-4 text-lg font-medium text-primary-soft sm:text-xl" data-id="element-45" data-mp="1i360asolt8bt">
          Aprende Coreano Fácil™
        </p>

        <ul className="mt-8 grid w-full max-w-md gap-3 text-left" data-id="element-46" data-mp="3ntfxrh3g1gvt">
          {closingIncludes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-47" data-mp="3sk65h0zcdvto">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary/25 text-primary-soft" data-id="element-48" data-mp="3slh7owd52vio">
                <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-49" data-mp="3iucwm7ql3ut4" />
              </span>
              <span className="text-sm leading-relaxed text-surface/85" data-id="element-50" data-mp="aejoohabjrno">{item}</span>
            </li>)}
        </ul>

        <div className="mt-10 flex flex-col items-center" data-id="element-51" data-mp="fdcrnfrzc09l">
          <span className="text-lg font-medium text-line line-through sm:text-xl" data-id="element-52" data-mp="fcuw6ld55q2q">{priceTotal}</span>
          <span className="font-display text-[48px] font-bold leading-none text-pink-light sm:text-7xl" data-id="element-53" data-mp="igceilr6cn0">
            {priceToday}
          </span>
        </div>

        <motion.a href="#comprar" animate={{
        y: [0, -2, 0]
      }} whileHover={{
        scale: 1.025,
        backgroundColor: 'rgb(255, 79, 163)',
        boxShadow: '0 14px 32px -8px rgba(255, 79, 163, 0.4)'
      }} whileTap={{
        scale: 0.98
      }} transition={{
        y: {
          duration: 2.4,
          ease: 'easeInOut',
          repeat: Infinity
        },
        type: 'spring',
        stiffness: 400,
        damping: 22
      }} className="mt-9 flex min-h-[58px] w-full max-w-md items-center justify-center gap-2 rounded-cta bg-pink px-6 py-4 text-base font-extrabold text-surface shadow-cta focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-light sm:text-lg" data-id="element-54" data-mp="2l5jiisntxcvw">
          {ctaLabel}
        </motion.a>
        <p className="mt-3 max-w-md text-xs leading-relaxed text-surface/65" data-id="element-55" data-mp="3xhwodjw2tdb">{paymentNote}</p>
      </motion.div>
    </section>;
}